import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-gradient-to-b from-teal-50 to-cream-50 py-12 sm:py-20" data-id="element-131">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-133">
          <p className="text-sm sm:text-base text-teal-700 font-semibold mb-4 uppercase tracking-wide" data-id="element-134">
            PARA LA PROFESIONAL QUE SON LAS 12 DE LA NOCHE Y TODAVÍA ESTÁ
            SENTADA PREPARANDO EL MATERIAL PARA EL PACIENTE DE MAÑANA…
          </p>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 leading-tight" data-id="element-135">
            Kit Clínico Cognitivo™
          </h1>

          <p className="text-xl sm:text-2xl text-gray-700 mb-6 font-medium" data-id="element-136">
            El sistema completo de intervención cognitiva para profesionales de
            la salud
          </p>

          <p className="text-lg text-gray-600 mb-8 italic" data-id="element-137">
            Mereces llegar a cada sesión con la tranquilidad de saber que ya
            tenés todo resuelto. Tu tiempo, tu energía y tu vocación valen
            demasiado para seguir armando actividades desde cero a las 12 de la
            noche.
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="mb-10" data-id="element-138">
            <a href="#checkout" className="block" data-id="element-139">
              <img src="https://cdn.magicpatterns.com/uploads/rbgm8zn7Cs1ZWU8uJJAv8D/ChatGPT_Image_7_may_2026__09_10_20_p.m.-removebg-preview.png" alt="Kit Clínico Cognitivo" className="w-full max-w-2xl mx-auto drop-shadow-2xl hover:scale-105 transition-transform duration-300 cursor-pointer" data-id="element-140" />
              {/* REPLACE THIS IMAGE WITH YOUR ACTUAL PRODUCT MOCKUP */}
            </a>
          </motion.div>

          <div className="bg-white rounded-lg p-6 shadow-md mb-8 text-left" data-id="element-141">
            <p className="text-sm font-bold text-teal-700 mb-4 uppercase text-center" data-id="element-142">
              NUEVO — 4 Módulos Clínicos + 4 Herramientas de Gestión + 2 Súper
              Bonos · Descarga inmediata
            </p>

            <ul className="space-y-3" data-id="element-143">
              {['300 fichas técnicas de estimulación cognitiva listas para imprimir y usar', 'Cobertura completa de 12 a 90 años en un solo sistema', 'Protocolos diferenciados por nivel de deterioro cognitivo', 'Herramientas de gestión clínica: screening, planificador y cartelería', 'Guía de alertas para saber cuándo derivar al neurólogo', 'Diseñado para psicólogos, terapeutas ocupacionales, fonoaudiólogos y psicopedagogos'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-144">
                  <Check className="w-5 h-5 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-145" />
                  <span className="text-gray-700" data-id="element-146">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="mb-6" data-id="element-147">
            <p className="text-2xl font-bold text-gray-900 mb-4" data-id="element-148">
              Pago único de $19.990 ARS · Acceso inmediato
            </p>
          </div>

          <CTAButton data-id="element-149">ACCEDER AL KIT CLÍNICO COGNITIVO™ AHORA</CTAButton>
        </motion.div>
      </div>
    </section>;
}